export default __webpack_public_path__ + "static/media/cholet16.83283871.jpg";